export default "__VITE_ASSET__Dub71j3w__"